<mat-card class="qr-card">

  <!-- Warning -->
  <div class="row" *ngIf="warning" style="margin-bottom: 20px;">
    <div class="fill-space"></div>
    <div>
      <mat-error>{{ warning }}</mat-error>
    </div>
    <div class="fill-space"></div>
  </div>

  <!-- Permission denied -->
  <div *ngIf="permissionDenied" class="row" style="margin: 16px 0;">
    <div class="fill-space"></div>
    <div>
      <div style="margin-bottom: 8px;">
        Kamera-tilgang er blokkert. Klikk «Gi tilgang» for å prøve igjen.
      </div>
      <button mat-raised-button color="primary" (click)="requestPermission()">Gi tilgang</button>
      <div style="font-size: 12px; opacity: .8; margin-top: 6px;">
        Hvis nettleseren fortsatt blokkerer:
        <span *ngIf="isIOS">iOS/Safari: Innstillinger → Safari → Kamera → Tillat.</span>
        <span *ngIf="!isIOS">Chrome: Klikk lås-ikonet i adressefeltet → Kamera → Tillat, og last siden på nytt.</span>
      </div>
    </div>
    <div class="fill-space"></div>
  </div>

  <!-- Loading -->
  <div *ngIf="isCameraLoading && !permissionDenied" class="row" style="margin: 80px;">
    <div class="fill-space"></div>
    <div>
      <mat-spinner></mat-spinner>
      <div class="row">
        <div class="fill-space"></div>
        <div style="margin-top: 20px;">Åpner kamera...</div>
        <div class="fill-space"></div>
      </div>
    </div>
    <div class="fill-space"></div>
  </div>

  <!-- Scanner group -->
  <div
    [style.display]="(isCameraLoading || permissionDenied) ? 'none' : 'block'"
    *ngIf="!disableScanner"
  >
    <div
      *ngIf="devices?.length > 0 && currentDevice"
      class="row"
      style="margin-bottom: 15px;"
    >
      <div class="fill-space"></div>
      <div>
        <!-- Camera selector -->
        <p-dropdown
          [options]="devices"
          [(ngModel)]="currentDevice"
          optionLabel="label"
          placeholder="Velg kamera"
          dropdownIcon="pi pi-camera"
        />
      </div>
      <div>
        <!-- Torch toggle -->
        <button
          style="position: absolute; top: 10px; right: 14px;"
          mat-mini-fab
          *ngIf="torchAvailable"
          (click)="toggleTorch()"
          [attr.aria-pressed]="torchEnabled"
          aria-label="Lommelykt"
          color="none"
        >
          <mat-icon class="torch-icon" *ngIf="torchEnabled">flashlight_on</mat-icon>
          <mat-icon class="torch-icon" *ngIf="!torchEnabled">flashlight_off</mat-icon>
        </button>
      </div>
      <div class="fill-space"></div>
    </div>

    <div class="row">
      <div class="qr-scanner-row" style="position: relative;">
        <!-- Scanner -->
        <zxing-scanner
          #scanner
          [(device)]="currentDevice"
          [formats]="allowedFormats"
          [tryHarder]="true"
          [torch]="torchEnabled"
          [autofocusEnabled]="true"
          (camerasFound)="onCamerasFound($event)"
          (permissionResponse)="onPermission($event)"
          (torchCompatible)="onTorchCompatible($event)"
          (scanSuccess)="onCodeResult($event)"
          previewFitMode="scale-down"
          [delayBetweenScanSuccess]="2000"
          class="qr-code-scanner"
          aria-label="QR-skanner"
        ></zxing-scanner>
      </div>

      <div>
        <!-- Zoom -->
        <p-slider *ngIf="zoomRange"
                  [(ngModel)]="zoomValue"
                  orientation="vertical"
                  styleClass="h-24rem"
                  [animate]="true"
                  [min]="zoomRange.min"
                  [max]="zoomRange.max"
                  [step]="zoomRange.step"
                  (onChange)="setZoom($event.value)"
        />
      </div>
    </div>
  </div>

</mat-card>
